import { render, staticRenderFns } from "./ProProfileAPage.vue?vue&type=template&id=bae803c0"
import script from "./ProProfileAPage.vue?vue&type=script&lang=js"
export * from "./ProProfileAPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports